import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import {
  PostUserConfig,
  GetCompany,
  GetUser,
  GetPolicyType,
  GetSubBookingCode,
  UpdateUserConfig,
  GetSubProduct,
  GetRTOLocationByCompanyID,
  GetVehicleMake,
  DeleteUserConfig,
  saveCommonConfig,
  updateCommonConfig,
  deleteCommonConfigById,
  GetFuelType,
  GetAddOn,
} from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import { Select } from "antd";
import { filterOption, filterSort } from "../../../Shared/CommonConstant";
import Button from "@mui/material/Button";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import { DeleteIcon } from "../../../Resources/Icons/icons";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// Added by Arun
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import Styles from "../../../UiComponents/Scss/AddPopup.module.scss";
import {
  getDisplayValue,
  getIdList,
  getIdValue,
  joinArrayValue,
} from "../../../Shared/formatArrayValue";

// Range fields can come back empty or without a range, so only real
// ranges are split
const getRangeValues = (value) => {
  const range = joinArrayValue(value);
  if (typeof range !== "string") return null;
  const rangeValues = range.toUpperCase().split(" TO ");
  return rangeValues.length >= 2
    ? rangeValues.map((item) => item.trim())
    : null;
};

// Record entries ({ id, value }) turned into Autocomplete option objects
const toOptions = (field) =>
  (Array.isArray(field) ? field : [field])
    .filter((item) => item && (item.id || item.value))
    .map((item) => ({ _id: item.id, label: item.value }));

// Booking codes are picked per booking code, so they match on that id
const getBookingCodeOptions = (data) =>
  toOptions(data?.bookingCode).map((option) => ({
    ...option,
    bookingCodeId: option._id,
  }));

// Product options are the sub products, labelled "Product - Sub Product"
const getProductOptions = (data) => {
  const productLabel = getDisplayValue(data?.product);
  const subProducts = toOptions(data?.subProduct);
  if (!subProducts.length) return toOptions(data?.product);
  return subProducts.map((option) => ({
    ...option,
    label: productLabel ? productLabel + " - " + option.label : option.label,
  }));
};

const optionLabel = (option) => option?.label || "";
const sameOption = (option, value) => option?._id === value?._id;
const sameBookingCode = (option, value) =>
  option?.bookingCodeId === value?.bookingCodeId;

// Options saved on the record are listed first in the edit dropdowns
const selectedFirst = (options, selected, isEqual) => {
  const isSelected = (option) => selected.some((item) => isEqual(option, item));
  return [
    ...options.filter(isSelected),
    ...options.filter((option) => !isSelected(option)),
  ];
};

// Selected options are ticked in the dropdown list
const renderMultiOption = (props, option, { selected }) => (
  <li {...props} key={option?._id || option?.label}>
    <Checkbox size="small" checked={selected} sx={{ mr: 1, p: 0.5 }} />
    {option?.label}
  </li>
);

const AddCommonConfig = (props) => {
  const { selectedData, formType, setOpenDrawer, ActiveFunction } = props;
  let formRef = useRef();
  console.log(selectedData);
  const initialValues = {
    companyId: "",
    bookingCodeId: "",
    productId: "",
    subProductId: "",
    policyTypeId: "",
    subBookingCodeId: "",
    bookingCode: "",
    product: "",
    PACover: "",
    CC: "",
    GVW: "",
    userConfig: {
      OD: "",
      TP: "",
      Net: "",
      fixedAmount: "",
    },
    branchConfig: {
      OD: "",
      TP: "",
      Net: "",
      fixedAmount: "",
    },
    receivableConfig: {
      OD: "",
      TP: "",
      Net: "",
      fixedAmount: "",
    },
    userId: "",
    locationId: "",
    make: "",
    year: "ALL",
    ccfrom: "",
    ccto: "",
    gvwfrom: "",
    gvwto: "",
    yearfrom: "",
    yearto: "",
    seatingCapacity: "ALL",
    seatingCapacityfrom: "",
    seatingCapacityto: "",
    odDisc: "ALL",
    oddiscfrom: "",
    oddiscto: "",
    fuelType: "",
    addOnId: "",
  };
  //Changed by Arun
  if (selectedData._id) {
    initialValues.activeDate = "";
  }

  const UserName = sessionStorage.getItem("UserId");
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [policyTypeDetails, setPolicyTypeDetails] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [locationDetails, setLocationDetails] = useState([]);
  const [resetValue, setResetValue] = useState(1);
  const [makeDetails, setMakeDetails] = useState([]);
  const [fuelTypeDetails, setFuelTypeDetails] = useState([]);
  const [addOnDetails, setAddOnDetails] = useState([]);

  // Changes by Arun
  const [branchManagerDetails, setBranchManagerDetails] = useState([]);
  const [defaultLocationDetails, setDefaultLocationDetails] = useState(
    formType === "edit" ? selectedData?.locationId : [],
  );
  const [bookingCodeValue, setBookingCodeValue] = useState(
    formType === "edit" ? getBookingCodeOptions(selectedData) : [],
  );
  const [productValue, setProductValue] = useState(
    formType === "edit" ? getProductOptions(selectedData) : [],
  );
  const [userValue, setUserValue] = useState(
    formType === "edit" ? toOptions(selectedData?.user) : [],
  );
  const [branchManagerValue, setBranchManagerValue] = useState(
    formType === "edit" ? getDisplayValue(selectedData?.branchManager) : null,
  );
  const [makeValue, setMakeValue] = useState(
    formType === "edit" ? toOptions(selectedData?.vehicleMake) : [],
  );
  const [policyTypeValue, setPolicyTypeValue] = useState(
    formType === "edit" ? toOptions(selectedData?.policyType) : [],
  );
  const [companyValue, setCompanyValue] = useState(
    formType === "edit" ? getDisplayValue(selectedData?.company) : null,
  );
  const [paCoverValue, setPaCoverValue] = useState(
    formType === "edit" ? joinArrayValue(selectedData?.PACover) : null,
  );
  const [fuelTypeValue, setFuelTypeValue] = useState(
    formType === "edit" ? toOptions(selectedData?.fuelType) : [],
  );
  const [addOnValue, setAddOnValue] = useState(
    formType === "edit" ? toOptions(selectedData?.addOn) : [],
  );
  const [ccValue, setCcValue] = useState(
    selectedData.CC === "ALL" ? "ALL" : formType === "add" ? "" : "Range",
  );
  const [gvwValue, setGvwValue] = useState(
    selectedData.GVW === "ALL" ? "ALL" : formType === "add" ? "" : "Range",
  );
  const [yearValue, setYearValue] = useState(
    selectedData.year === "ALL" ? "ALL" : formType === "add" ? "" : "Range",
  );
  const [openCcRangeBox, setOpenCcRangeBox] = useState(
    selectedData.CC === "ALL" ? false : formType === "add" ? false : true,
  );
  const [openGvwRangeBox, setOpenGvwRangeBox] = useState(
    selectedData.GVW === "ALL" ? false : formType === "add" ? false : true,
  );
  const [openYearRangeBox, setOpenYearRangeBox] = useState(
    selectedData.year === "ALL" ? false : formType === "add" ? false : true,
  );
  const [seatingCapacityValue, setSeatingCapacityValue] = useState(
    selectedData.seatingCapacity === "ALL"
      ? "ALL"
      : formType === "add"
        ? ""
        : "Range",
  );
  const [openSeatingCapacityRangeBox, setOpenSeatingCapacityRangeBox] =
    useState(
      selectedData.seatingCapacity === "ALL"
        ? false
        : formType === "add"
          ? false
          : true,
    );
  const [odDiscountValue, setOdDiscountValue] = useState(
    selectedData.odDisc === "ALL" ? "ALL" : formType === "add" ? "" : "Range",
  );
  const [openOdDiscountRangeBox, setOpenOdDiscountRangeBox] = useState(
    selectedData.odDisc === "ALL" ? false : formType === "add" ? false : true,
  );
  const [saveandCreateNewBtn, setSaveandCreateNewBtn] = useState(false); // Changed by Arun
  useEffect(() => {
    if (formType === "edit") {
      Object.keys(initialValues).forEach((el) => {
        initialValues[el] = selectedData[el];
      });
      formRef.setFieldValue("filterId", selectedData?._id);
      formRef.setFieldValue("companyId", getIdValue(selectedData?.company));
      formRef.setFieldValue(
        "bookingCodeId",
        getIdList(selectedData?.bookingCode),
      );
      formRef.setFieldValue(
        "policyTypeId",
        getIdList(selectedData?.policyType),
      );
      formRef.setFieldValue("productId", getIdList(selectedData?.product));
      formRef.setFieldValue("make", selectedData?.make);
      formRef.setFieldValue(
        "subBookingCodeId",
        getIdList(selectedData?.subBookingCode),
      );
      formRef.setFieldValue(
        "subProductId",
        getIdList(selectedData?.subProduct),
      );
      formRef.setFieldValue("userId", getIdList(selectedData?.user));
      formRef.setFieldValue(
        "branchManagerId",
        getIdValue(selectedData?.branchManager),
      );
      if (selectedData?.CC !== "ALL") {
        const ccRangeValues = getRangeValues(selectedData?.CC);
        if (ccRangeValues) {
          formRef.setFieldValue("ccfrom", ccRangeValues[0]);
          formRef.setFieldValue("ccto", ccRangeValues[1]);
        }
      }
      if (selectedData?.GVW !== "ALL") {
        const gvwRangeValues = getRangeValues(selectedData?.GVW);
        if (gvwRangeValues) {
          formRef.setFieldValue("gvwfrom", gvwRangeValues[0]);
          formRef.setFieldValue("gvwto", gvwRangeValues[1]);
        }
      }
      if (selectedData?.year !== "ALL") {
        const yearRangeValues = getRangeValues(selectedData?.year);
        if (yearRangeValues) {
          formRef.setFieldValue("yearfrom", yearRangeValues[0]);
          formRef.setFieldValue("yearto", yearRangeValues[1]);
        }
      }
      if (
        selectedData?.seatingCapacity &&
        selectedData?.seatingCapacity !== "ALL"
      ) {
        const seatingCapacityRangeValues = getRangeValues(
          selectedData?.seatingCapacity,
        );
        if (seatingCapacityRangeValues) {
          formRef.setFieldValue(
            "seatingCapacityfrom",
            seatingCapacityRangeValues[0],
          );
          formRef.setFieldValue(
            "seatingCapacityto",
            seatingCapacityRangeValues[1],
          );
        }
      }
      if (selectedData?.odDisc && selectedData?.odDisc !== "ALL") {
        const odDiscountRangeValues = getRangeValues(selectedData?.odDisc);
        if (odDiscountRangeValues) {
          formRef.setFieldValue("oddiscfrom", odDiscountRangeValues[0]);
          formRef.setFieldValue("oddiscto", odDiscountRangeValues[1]);
        }
      }
      formRef.setFieldValue("fuelType", getIdList(selectedData?.fuelType));
      formRef.setFieldValue("addOnId", getIdList(selectedData?.addOn));
    }
    formRef.setFieldValue(initialValues);
  }, []);

  // Sync fuelTypeValue with fuelTypeDetails when loading in edit mode
  useEffect(() => {
    if (formType === "edit" && fuelTypeDetails.length > 0) {
      setFuelTypeValue(toOptions(selectedData?.fuelType));
    }
  }, [fuelTypeDetails, formType, selectedData?.fuelType]);

  // Changed by Arun
  const deleteFunction = () => {
    deleteCommonConfigById(selectedData._id).then((res) => {
      ActiveFunction();
      setOpenDrawer(false);
    });
  };

  const onSubmit = (e) => {
    console.log(e);
    // return true;
    e.createdBy = UserName;
    if (openCcRangeBox) {
      if (e.ccfrom && e.ccto) {
        e.CC = String(e.ccfrom + " to " + e.ccto);
      } else {
        ToastError("Enter CC range values");
      }
    } else {
      e.CC = "ALL";
    }
    if (openGvwRangeBox) {
      if (e.gvwfrom && e.gvwto) {
        e.GVW = String(e.gvwfrom + " to " + e.gvwto);
      } else {
        ToastError("Enter GVW range values");
      }
    } else {
      e.GVW = "ALL";
    }
    if (openYearRangeBox) {
      if (e.yearfrom && e.yearto) {
        e.year = String(e.yearfrom + " to " + e.yearto);
      } else {
        ToastError("Enter Year range values");
      }
    } else {
      e.year = "ALL";
    }
    if (openSeatingCapacityRangeBox) {
      if (e.seatingCapacityfrom && e.seatingCapacityto) {
        e.seatingCapacity = String(
          e.seatingCapacityfrom + " to " + e.seatingCapacityto,
        );
      } else {
        ToastError("Enter Seating Capacity range values");
      }
    } else {
      e.seatingCapacity = "ALL";
    }
    if (openOdDiscountRangeBox) {
      if (e.oddiscfrom && e.oddiscto) {
        e.odDisc = String(e.oddiscfrom + " to " + e.oddiscto);
      } else {
        ToastError("Enter OD Discount range values");
      }
    } else {
      e.odDisc = "ALL";
    }
    // Fuel type is multi select in add mode and single select in edit mode
    const isFuelTypeSelected = Array.isArray(e.fuelType)
      ? e.fuelType.length > 0
      : Boolean(e.fuelType);
    if (e.CC && e.GVW && e.year && e.seatingCapacity && e.odDisc) {
      if (
        e.userId &&
        e.policyTypeId &&
        e.companyId &&
        e.bookingCodeId &&
        e.productId &&
        e.PACover &&
        e.make &&
        isFuelTypeSelected &&
        e.CC &&
        e.GVW &&
        e.year
      ) {
        const ApiType =
          formType === "edit" ? updateCommonConfig(e) : saveCommonConfig(e);
        ApiType.then((res) => {
          if (!saveandCreateNewBtn) {
            ActiveFunction();
            setOpenDrawer(false);
          } else {
            setSaveandCreateNewBtn(false);
          }
        }).catch((err) => {
          console.log(err);
        });
      } else {
        ToastError("Enter All fields");
      }
    }
  };

  const paCoverDetails = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Yes",
      value: "yes",
    },
    {
      label: "No",
      value: "no",
    },
  ];
  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      modifiedCompanyDetails.unshift({
        _id: "ALL",
        value: "ALL",
        shortName: "ALL",
        label: "ALL",
      });
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData).then((res) => {
      let FilteredData = [];
      res.data.map((e) => {
        if (e.isEnabled && e?.userType.includes("user") && e.isEnabled) {
          FilteredData.push({
            ...e,
            label: e.name,
            value: e._id,
          });
        }
      });
      // Changes by Arun
      const FilterUserType = FilteredData?.filter((item) =>
        item.userType.includes("branchManager"),
      );
      FilteredData.unshift({
        name: "",
        mobileNumber: "",
        email: "",
        _id: "ALL",
        label: "ALL",
        value: "ALL",
        isEnabled: true,
      });
      FilterUserType.unshift({ _id: "ALL", value: "ALL", label: "ALL" });
      setBranchManagerDetails(FilterUserType);
      setUserDetails(FilteredData.filter(Boolean));
    });
  };
  const GetBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: "combineData" }).then((res) => {
      // Show unique booking codes only (one record per booking code)
      const modifiedBookingCodeDetails = [
        ...new Map(
          res.data
            .filter((e) => e.isEnabled)
            .map((e) => [
              e.bookingCodeId,
              {
                ...e,
                label: e.bookingCode,
                value: e._id,
              },
            ]),
        ).values(),
      ];
      setBookingCodeDetails(modifiedBookingCodeDetails);
    });
  };

  const GetProductDetails = () => {
    GetSubProduct({ isAscending: "combineData" }).then((res) => {
      const modifiedProductDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.product + " - " + e.subProduct,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setProductDetails(modifiedProductDetails);
    });
  };

  const GetPolicyTypeDetails = () => {
    GetPolicyType({ isAscending: true }).then((res) => {
      const modifiedPolicyTypeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.policyType,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setPolicyTypeDetails(modifiedPolicyTypeDetails);
    });
  };

  // vehicleMake added by gokul..
  const [productID, setProductID] = useState([]);

  const GetVehicleMakeDetails = () => {
    // console.log("productID ", productID);
    // console.log("selectedData ", selectedData);
    GetVehicleMake({ isAscending: false }).then((res) => {
      const modifiedVehicleMakeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.vehicleMake,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      // Changes by Arun - the record holds a list of products
      const productIds =
        productID?.length > 0 ? productID : getIdList(selectedData?.product);
      const filterData = modifiedVehicleMakeDetails.filter((item) =>
        productIds.includes(item.productID),
      );
      filterData.unshift({ _id: "ALL", label: "ALL", value: "ALL" });
      // console.log("filterData ", filterData);

      setMakeDetails(filterData);
    });
  };

  useEffect(() => GetVehicleMakeDetails(), [productID]);

  // Chages by Arun
  const GetRtoLocationFunction = (id) => {
    if (!id) {
      return true;
    }
    GetRTOLocationByCompanyID(id).then((res) => {
      setLocationDetails(res?.data?.location || []);
    });
  };
  useEffect(() => {
    GetUserDetails();
    GetCompanyDetails();
    GetBookingCodeDetails();
    GetProductDetails();
    GetPolicyTypeDetails();
    GetFuelTypeDetails();
    GetAddOnDetails();
  }, []);

  const GetFuelTypeDetails = () => {
    GetFuelType({ isAscending: true }).then((res) => {
      const modifiedFuelTypeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.fuelType,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      modifiedFuelTypeDetails.unshift({
        _id: "ALL",
        value: "ALL",
        fuelType: "ALL",
        label: "ALL",
      });
      setFuelTypeDetails(modifiedFuelTypeDetails);
    });
  };

  const GetAddOnDetails = () => {
    GetAddOn({ isAscending: true }).then((res) => {
      const modifiedAddOnDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.addOn,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      modifiedAddOnDetails.unshift({
        _id: "ALL",
        value: "ALL",
        addOn: "ALL",
        label: "ALL",
      });
      setAddOnDetails(modifiedAddOnDetails);
    });
  };

  const { Option } = Select;

  return (
    <>
      <div className="DrawerContainer">
        <Grid container className="DrawerHeader">
          <Grid item xs={6} sm={6}>
            <Typography>{`${
              formType === "add" ? "Add" : "Edit"
            } Common Configuration`}</Typography>
          </Grid>
          <Grid item xs={6} sm={6} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => setOpenDrawer(false)}
              sx={{
                cursor: "pointer",
                height: "18px",
                width: "18px",
                fontWeight: 600,
              }}
            />
          </Grid>
        </Grid>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            onSubmit(values);
          }}
          innerRef={(ref) => {
            if (ref) {
              formRef = ref;
            }
          }}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className={Styles.addContent}>
                <Grid container spacing={2}>
                  <Grid item sm={6} xs={12}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      User
                    </Typography>
                    {formType === "edit" ? (
                      <Autocomplete
                        multiple
                        className="AutoComplete_InputBox AutoComplete_MultiBox"
                        name="userId"
                        options={selectedFirst(
                          userDetails,
                          toOptions(selectedData?.user),
                          sameOption,
                        )}
                        value={userValue}
                        getOptionLabel={optionLabel}
                        renderOption={renderMultiOption}
                        isOptionEqualToValue={sameOption}
                        onChange={(e, v) => {
                          setFieldValue(
                            "userId",
                            v.map((option) => option?._id),
                          );
                          setUserValue(v);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select User" />
                        )}
                      />
                    ) : (
                      <Select
                        mode="multiple"
                        // className="w-100 AntdSelect"
                        dropdownStyle={{ zIndex: 11000 }}
                        className="AutoComplete_InputBox"
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select User"
                        onChange={(selectedValues) => {
                          setFieldValue("userId", selectedValues);
                        }}
                      >
                        {userDetails.map((el) => (
                          <Option value={el.value} key={el.value}>
                            {el.label +
                              " - " +
                              el.mobileNumber +
                              " - " +
                              el.email}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Branch Manager
                    </Typography>
                    {formType === "edit" ? (
                      <Autocomplete
                        className="AutoComplete_InputBox"
                        name="branchManagerId"
                        options={branchManagerDetails}
                        value={branchManagerValue}
                        onInputChange={(e, v) => setBranchManagerValue(v)}
                        onChange={(e, v) => {
                          setFieldValue("branchManagerId", v?._id);
                          setBranchManagerValue(v?.label);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Branch Manager"
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option?.label === value
                        }
                      />
                    ) : (
                      <Select
                        mode="single"
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Branch Manager"
                        onChange={(selectedValues) => {
                          setFieldValue("branchManagerId", selectedValues);
                        }}
                        dropdownStyle={{ zIndex: 11000 }}
                      >
                        {branchManagerDetails.map((el) => (
                          <Option value={el._id} key={el.value}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Company
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      name="companyId"
                      options={companyDetails}
                      value={companyValue}
                      onChange={(e, v) => {
                        setFieldValue("companyId", v?._id);
                        // Changes by Arun
                        setDefaultLocationDetails([]);
                        setResetValue(resetValue + 1);
                        setFieldValue("locationId", null);
                        setCompanyValue(v?.label);
                        GetRtoLocationFunction(v?._id);
                      }}
                      // Changes by Arun
                      onInputChange={(e, v) => {
                        GetRtoLocationFunction(selectedData?.company?.id);
                      }}
                      clearIcon={false}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Company" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Policy Type
                    </Typography>
                    {formType === "edit" ? (
                      <Autocomplete
                        multiple
                        className="AutoComplete_InputBox AutoComplete_MultiBox"
                        name="policyTypeId"
                        options={selectedFirst(
                          policyTypeDetails,
                          toOptions(selectedData?.policyType),
                          sameOption,
                        )}
                        value={policyTypeValue}
                        getOptionLabel={optionLabel}
                        renderOption={renderMultiOption}
                        isOptionEqualToValue={sameOption}
                        onChange={(e, v) => {
                          setFieldValue(
                            "policyTypeId",
                            v.map((option) => option?._id),
                          );
                          setPolicyTypeValue(v);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Policy Type"
                          />
                        )}
                      />
                    ) : (
                      <Select
                        mode="multiple"
                        dropdownStyle={{ zIndex: 11000 }}
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Policy Type"
                        onChange={(selectedValues) => {
                          setFieldValue("policyTypeId", selectedValues);
                        }}
                      >
                        {policyTypeDetails.map((el) => (
                          <Option value={el._id} key={el.value}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Location
                    </Typography>
                    <Select
                      dropdownStyle={{ zIndex: 11000 }}
                      className="AutoComplete_InputBox"
                      mode="multiple"
                      style={{ borderRadius: "0px", height: "43px" }}
                      maxTagCount="responsive"
                      filterOption={filterOption}
                      placeholder="Select Location"
                      // Changes by Arun
                      defaultValue={defaultLocationDetails}
                      filterSort={filterSort}
                      onChange={(selectedValues) => {
                        setFieldValue("locationId", selectedValues);
                      }}
                      key={resetValue}
                    >
                      {locationDetails.map((el) => (
                        <Option value={el.id} key={el.id}>
                          {el.value}
                        </Option>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Booking Code
                    </Typography>
                    {formType === "edit" ? (
                      <Autocomplete
                        multiple
                        className="AutoComplete_InputBox AutoComplete_MultiBox"
                        options={selectedFirst(
                          bookingCodeDetails,
                          getBookingCodeOptions(selectedData),
                          sameBookingCode,
                        )}
                        value={bookingCodeValue}
                        getOptionLabel={optionLabel}
                        renderOption={renderMultiOption}
                        isOptionEqualToValue={sameBookingCode}
                        onChange={(e, v) => {
                          setFieldValue(
                            "bookingCodeId",
                            v.map((option) => option?.bookingCodeId),
                          );
                          setFieldValue(
                            "subBookingCodeId",
                            v.map((option) => option?._id),
                          );
                          setBookingCodeValue(v);
                        }}
                        clearIcon={false}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Booking Code"
                          />
                        )}
                      />
                    ) : (
                      <Select
                        mode="multiple"
                        dropdownStyle={{ zIndex: 11000 }}
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Booking Code"
                        onChange={(selectedValues) => {
                          try {
                            const parsedObjects = selectedValues.map((value) =>
                              JSON.parse(value),
                            );
                            const bookingCodeValues = parsedObjects.map(
                              (el) => ({
                                bookingCodeId:
                                  el.bookingCodeId !== undefined
                                    ? el.bookingCodeId
                                    : "",
                                subBookingCodeId:
                                  el._id !== undefined ? el._id : "",
                              }),
                            );
                            setFieldValue(
                              "bookingCodeId",
                              bookingCodeValues.map((obj) => obj.bookingCodeId),
                            );
                            setFieldValue(
                              "subBookingCodeId",
                              bookingCodeValues.map(
                                (obj) => obj.subBookingCodeId,
                              ),
                            );
                            setFieldValue("bookingCode", bookingCodeValues);
                          } catch (error) {
                            console.error("Error parsing JSON:", error);
                          }
                        }}
                      >
                        {bookingCodeDetails.map((el) => (
                          <Option value={JSON.stringify(el)} key={el.value}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Product & Sub Product
                    </Typography>
                    {formType === "edit" ? (
                      <Autocomplete
                        multiple
                        className="AutoComplete_InputBox AutoComplete_MultiBox"
                        name="productId"
                        options={selectedFirst(
                          productDetails,
                          getProductOptions(selectedData),
                          sameOption,
                        )}
                        value={productValue}
                        getOptionLabel={optionLabel}
                        renderOption={renderMultiOption}
                        isOptionEqualToValue={sameOption}
                        onChange={(e, v) => {
                          const productIds = [
                            ...new Set(v.map((option) => option?.productID)),
                          ].filter(Boolean);
                          setFieldValue("productId", productIds);
                          setFieldValue(
                            "subProductId",
                            v.map((option) => option?._id),
                          );
                          setProductID(productIds);
                          setProductValue(v);
                        }}
                        clearIcon={false}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Product & Sub Product"
                          />
                        )}
                      />
                    ) : (
                      <Select
                        mode="multiple"
                        dropdownStyle={{ zIndex: 11000 }}
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Product & Sub Product"
                        onChange={(selectedValues) => {
                          try {
                            const parsedObjects = selectedValues.map((value) =>
                              JSON.parse(value),
                            );
                            const productValues = parsedObjects.map((el) => ({
                              productId:
                                el.productID !== undefined ? el.productID : "",
                              subProductId: el._id !== undefined ? el._id : "",
                            }));

                            setFieldValue(
                              "productId",
                              productValues.map((obj) => obj.productId),
                            );
                            setProductID(
                              productValues.map((obj) => obj.productId),
                            );
                            setFieldValue(
                              "subProductId",
                              productValues.map((obj) => obj.subProductId),
                            );
                            setFieldValue("product", productValues);
                          } catch (error) {
                            console.error("Error parsing JSON:", error);
                          }
                        }}
                      >
                        {productDetails.map((el) => (
                          <Option value={JSON.stringify(el)} key={el.value}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Grid>

                  <Grid item xs={12} sm={openCcRangeBox ? 2 : 6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      CC
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      name="CC"
                      value={ccValue}
                      options={[{ label: "ALL" }, { label: "Range" }]}
                      clearIcon={false}
                      onChange={(e, v) => {
                        if (v?.label === "ALL") {
                          setCcValue(v.label);
                          setOpenCcRangeBox(false);
                          setFieldValue("ccfrom", "");
                          setFieldValue("ccto", "");
                        } else {
                          setCcValue(v.label);
                          setOpenCcRangeBox(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select CC" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value?.label
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openCcRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      CC Form
                    </Typography>
                    <Field
                      name="ccfrom"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openCcRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      CC To
                    </Typography>
                    <Field
                      name="ccto"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={openGvwRangeBox ? 2 : 6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      GVW
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      name="GVW"
                      value={gvwValue}
                      options={[{ label: "ALL" }, { label: "Range" }]}
                      clearIcon={false}
                      onChange={(e, v) => {
                        if (v?.label === "ALL") {
                          setGvwValue(v.label);
                          setOpenGvwRangeBox(false);
                          setFieldValue("gvwfrom", "");
                          setFieldValue("gvwto", "");
                        } else {
                          setGvwValue(v.label);
                          setOpenGvwRangeBox(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select GVW" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value?.label
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openGvwRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      GVW Form
                    </Typography>
                    <Field
                      name="gvwfrom"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openGvwRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      GVW To
                    </Typography>
                    <Field
                      name="gvwto"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      PA Cover
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      name="PACover"
                      options={paCoverDetails}
                      value={paCoverValue}
                      onChange={(e, v) => {
                        setFieldValue("PACover", v?.value);
                        setPaCoverValue(v?.label);
                      }}
                      clearIcon={false}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select PA Cover" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Make
                    </Typography>
                    {/* Changes by Arun */}
                    {formType === "edit" ? (
                      <Autocomplete
                        multiple
                        className="AutoComplete_InputBox AutoComplete_MultiBox"
                        name="make"
                        options={selectedFirst(
                          makeDetails,
                          toOptions(selectedData?.vehicleMake),
                          sameOption,
                        )}
                        value={makeValue}
                        getOptionLabel={optionLabel}
                        renderOption={renderMultiOption}
                        isOptionEqualToValue={sameOption}
                        onChange={(e, v) => {
                          //Changes by Arun
                          setFieldValue(
                            "make",
                            v.map((option) => option?._id),
                          );
                          setMakeValue(v);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select Make" />
                        )}
                      />
                    ) : (
                      <Select
                        mode="multiple"
                        dropdownStyle={{ zIndex: 11000 }}
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Make"
                        onChange={(selectedValues) => {
                          console.log(selectedValues);
                          setFieldValue("make", selectedValues);
                        }}
                      >
                        {makeDetails.map((el) => (
                          <Option value={el._id} key={el._id}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Fuel Type
                    </Typography>
                    {formType === "edit" ? (
                      <Autocomplete
                        multiple
                        className="AutoComplete_InputBox AutoComplete_MultiBox"
                        name="fuelType"
                        options={selectedFirst(
                          fuelTypeDetails,
                          toOptions(selectedData?.fuelType),
                          sameOption,
                        )}
                        value={fuelTypeValue}
                        getOptionLabel={optionLabel}
                        renderOption={renderMultiOption}
                        isOptionEqualToValue={sameOption}
                        onChange={(e, v) => {
                          setFieldValue(
                            "fuelType",
                            v.map((option) => option?._id),
                          );
                          setFuelTypeValue(v);
                        }}
                        clearIcon={false}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Fuel Type"
                          />
                        )}
                      />
                    ) : (
                      <Select
                        mode="multiple"
                        dropdownStyle={{ zIndex: 11000 }}
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Fuel Type"
                        onChange={(selectedValues) => {
                          setFieldValue("fuelType", selectedValues);
                        }}
                      >
                        {fuelTypeDetails.map((el) => (
                          <Option value={el._id} key={el._id}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Add On
                    </Typography>
                    {formType === "edit" ? (
                      <Autocomplete
                        multiple
                        className="AutoComplete_InputBox AutoComplete_MultiBox"
                        name="addOnId"
                        options={selectedFirst(
                          addOnDetails,
                          toOptions(selectedData?.addOn),
                          sameOption,
                        )}
                        value={addOnValue}
                        getOptionLabel={optionLabel}
                        renderOption={renderMultiOption}
                        isOptionEqualToValue={sameOption}
                        onChange={(e, v) => {
                          setFieldValue(
                            "addOnId",
                            v.map((option) => option?._id),
                          );
                          setAddOnValue(v);
                        }}
                        clearIcon={false}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select Add On" />
                        )}
                      />
                    ) : (
                      <Select
                        mode="multiple"
                        dropdownStyle={{ zIndex: 11000 }}
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Add On"
                        onChange={(selectedValues) => {
                          setFieldValue("addOnId", selectedValues);
                        }}
                      >
                        {addOnDetails.map((el) => (
                          <Option value={el._id} key={el._id}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={openYearRangeBox ? 2 : 6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Year
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      value={yearValue}
                      options={[{ label: "ALL" }, { label: "Range" }]}
                      clearIcon={false}
                      onChange={(e, v) => {
                        if (v?.label === "ALL") {
                          setYearValue(v.label);
                          setOpenYearRangeBox(false);
                          setFieldValue("yearfrom", "");
                          setFieldValue("yearto", "");
                        } else {
                          setYearValue(v.label);
                          setOpenYearRangeBox(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Year" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value?.label
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openYearRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Year Form
                    </Typography>
                    <Field
                      type="number"
                      name="yearfrom"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openYearRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Year To
                    </Typography>
                    <Field
                      type="number"
                      name="yearto"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={openSeatingCapacityRangeBox ? 2 : 6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Seating Capacity
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      value={seatingCapacityValue}
                      options={[{ label: "ALL" }, { label: "Range" }]}
                      clearIcon={false}
                      onChange={(e, v) => {
                        if (v?.label === "ALL") {
                          setSeatingCapacityValue(v.label);
                          setOpenSeatingCapacityRangeBox(false);
                          setFieldValue("seatingCapacityfrom", "");
                          setFieldValue("seatingCapacityto", "");
                        } else {
                          setSeatingCapacityValue(v.label);
                          setOpenSeatingCapacityRangeBox(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Seating Capacity"
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value?.label
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{
                      display: openSeatingCapacityRangeBox ? "block" : "none",
                    }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Seating Capacity From
                    </Typography>
                    <Field
                      type="number"
                      name="seatingCapacityfrom"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{
                      display: openSeatingCapacityRangeBox ? "block" : "none",
                    }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Seating Capacity To
                    </Typography>
                    <Field
                      type="number"
                      name="seatingCapacityto"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={openOdDiscountRangeBox ? 2 : 6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      OD Discount
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      value={odDiscountValue}
                      options={[{ label: "ALL" }, { label: "Range" }]}
                      clearIcon={false}
                      onChange={(e, v) => {
                        if (v?.label === "ALL") {
                          setOdDiscountValue(v.label);
                          setOpenOdDiscountRangeBox(false);
                          setFieldValue("oddiscfrom", "");
                          setFieldValue("oddiscto", "");
                        } else {
                          setOdDiscountValue(v.label);
                          setOpenOdDiscountRangeBox(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select OD Discount"
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value?.label
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openOdDiscountRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      OD Discount From
                    </Typography>
                    <Field
                      type="number"
                      name="oddiscfrom"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openOdDiscountRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      OD Discount To
                    </Typography>
                    <Field
                      type="number"
                      name="oddiscto"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  {/* Changed by Arun */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    // sx={{
                    //   display: selectedData?.isEnabled ? "display" : "none",
                    // }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Active Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        name="activeDate"
                        className="Date_Picker w-100"
                        value={dayjs(values?.activeDate)}
                        onChange={(e) => setFieldValue("activeDate", e?.$d)}
                        format={"DD/MM/YYYY"}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <div style={{ marginTop: "20px" }}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ArrowDropDownIcon />}
                      aria-controls="panel2-content"
                      id="panel2-header"
                    >
                      <Typography component="span">User Config</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            OD %
                          </Typography>
                          <Field
                            name="userConfig.OD"
                            placeholder="Enter OD"
                            className="InputFiled"
                            style={{ textTransform: "uppercase" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            TP %
                          </Typography>
                          <Field
                            name="userConfig.TP"
                            placeholder="Enter TP"
                            className="InputFiled"
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            NET %
                          </Typography>
                          <Field
                            name="userConfig.Net"
                            placeholder="Enter NET"
                            className="InputFiled"
                            style={{ textTransform: "uppercase" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Fixed Amount
                          </Typography>
                          <Field
                            type="number"
                            name="userConfig.fixedAmount"
                            placeholder="Enter Fixed Amount"
                            className="InputFiled"
                          />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ArrowDropDownIcon />}
                      aria-controls="panel2-content"
                      id="panel2-header"
                    >
                      <Typography component="span">Branch Config</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            OD %
                          </Typography>
                          <Field
                            name="branchConfig.OD"
                            placeholder="Enter OD"
                            className="InputFiled"
                            style={{ textTransform: "uppercase" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            TP %
                          </Typography>
                          <Field
                            name="branchConfig.TP"
                            placeholder="Enter TP"
                            className="InputFiled"
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            NET %
                          </Typography>
                          <Field
                            name="branchConfig.Net"
                            placeholder="Enter NET"
                            className="InputFiled"
                            style={{ textTransform: "uppercase" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Fixed Amount
                          </Typography>
                          <Field
                            type="number"
                            name="branchConfig.fixedAmount"
                            placeholder="Enter Fixed Amount"
                            className="InputFiled"
                          />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ArrowDropDownIcon />}
                      aria-controls="panel2-content"
                      id="panel2-header"
                    >
                      <Typography component="span">
                        Receivable Config
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            OD %
                          </Typography>
                          <Field
                            name="receivableConfig.OD"
                            placeholder="Enter OD"
                            className="InputFiled"
                            style={{ textTransform: "uppercase" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            TP %
                          </Typography>
                          <Field
                            name="receivableConfig.TP"
                            placeholder="Enter TP"
                            className="InputFiled"
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            NET %
                          </Typography>
                          <Field
                            name="receivableConfig.Net"
                            placeholder="Enter NET"
                            className="InputFiled"
                            style={{ textTransform: "uppercase" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            Fixed Amount
                          </Typography>
                          <Field
                            type="number"
                            name="receivableConfig.fixedAmount"
                            placeholder="Enter Fixed Amount"
                            className="InputFiled"
                          />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>
              <div className="Dialog_Footer">
                <Button
                  onClick={() => setOpenDrawer(false)}
                  className="Dialog_Cancel"
                >
                  Cancel
                </Button>
                <Button type="submit" className="Dialog_Save">
                  {selectedData?._id ? "Update" : "Save"}
                </Button>
                {/* Changed by Arun */}
                <Button
                  sx={{ display: selectedData?._id ? "none" : "display" }}
                  type="submit"
                  className="Dialog_Save_Exit"
                  onClick={() => setSaveandCreateNewBtn(true)}
                >
                  Save & Create New
                </Button>
                <Button
                  sx={{ display: selectedData?._id ? "inline-flex" : "none" }}
                  endIcon={<DeleteIcon />}
                  onClick={() => deleteFunction()}
                  className="Dialog_Cancel"
                >
                  Delete
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default AddCommonConfig;
